<canvas
	baseChart
	[data]="activeChart.data"
	[options]="activeChart.options"
	[type]="activeChart.type"
	width="100%"
	(chartClick)="onDoughnutChartPieceSelect($event)"
	height="45rem"
></canvas>
